import { yup } from '@medely/ui-kit';
import { REASON_OTHER_VALUE } from './constants';

export const editClockTimesSchema = yup.object().shape({
  approved_clock_in_date: yup.string().required('Required'),
  approved_clock_in_time: yup.string().required('Required'),
  approved_clock_out_date: yup.string().required('Required'),
  approved_clock_out_time: yup.string().required('Required'),
  reason: yup.string().required('Please select a reason'),
  reason_other: yup.string().when('reason', {
    is: REASON_OTHER_VALUE,
    then: (schema) => schema.required('Please provide a note when reason is Other'),
    otherwise: (schema) => schema.optional(),
  }),
});

export type EditClockTimesFormValues = yup.InferType<typeof editClockTimesSchema>;
